<template>
    <div>
        <h2>
            <div v-if="icon">
                <div :class="['ico-' + icon + ' epic mb-2']"></div>
            </div>
            {{ title }}
        </h2>

        <h3>
            {{ product.code }} |
            <span v-if="reservation.customer.name">{{ reservation.customer.name }}</span>
            <span v-if="reservation.customer.surname">{{ reservation.customer.surname }}</span> |
            {{ product.name }} |

            <date-and-time :reservation="reservation"></date-and-time>
        </h3>

        <div v-if="reservation.status === -5" class="radius-large p-2 bg-color-6 d-inline-block normal">
            This reservation has been canceled
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import DateAndTime from '../DateAndTime'

    export default {
        props: {
            title: String,
            icon: {
                type: String,
                required: false
            }
        },
        computed: {
            ...mapGetters([
                'getSelectedReservation',
                'getClonedReservation',
            ]),
            reservation: function() {
                if (this.getClonedReservation) {
                    return this.getClonedReservation;
                }

                return this.getSelectedReservation;
            },
            product: function() {
                return this.reservation.event.product;
            }
        },
        components: {
            DateAndTime,
        }
    }
</script>



// WEBPACK FOOTER //
// ViewHeader.vue?8be46dc4